import { Component } from 'san';
import * as _ from 'lodash';

import { IShowToasterParams, IToasterItem } from 'src/models';
import { TOASTER_TIMEOUT, TOASTER_TIMEOUT_INFINITY } from 'src/consts';
import { EMessageContentType, EMessageType } from 'src/enums';

export default class Toaster extends Component {
    id = 0;   // toast item的id，是其唯一标识

    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        items: IToasterItem[];
        messageContentTypeEnum: any;
        messageTypeEnum: any;
    } {
        return {
            isShow: false,
            items: [],
            messageContentTypeEnum: EMessageContentType,
            messageTypeEnum: EMessageType,
        };
    }

    inited() {
    }

    //#region owner调用
    show(params: IShowToasterParams): number {
        this.data.set('isShow', true);
        const item: IToasterItem = {
            id: ++this.id,
            type: params.type,
            title: params.title || '',
            contents: params.contents || [],
            timeout: params.timeout || TOASTER_TIMEOUT,
            content_type: params.content_type,
            message_type: params.message_type,
            url: params.url,
            need_jump: params.need_jump,
        };
        this.data.push('items', item);
        if (TOASTER_TIMEOUT_INFINITY === item.timeout) {
            return item.id;
        }
        setTimeout(() => {
            this.remove(item.id);
        }, item.timeout);
        return item.id;
    }

    remove(id: number) {
        const dataKey = 'items';
        const items: IToasterItem[] = this.data.get(dataKey);
        const index = _.findIndex(items, { id });
        if (-1 !== index) {
            this.data.removeAt(dataKey, index);
        }
    }
    //#endregion
}